import { brokerApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const BROKERS_ACTION_TYPE = createNamedActions('brokers', {
  GET_BROKERS: 'GET_BROKERS',
  CREATE_BROKER: 'CREATE_BROKER',
  EDIT_BROKER: 'EDIT_BROKER',
  DELETE_BROKER: 'DELETE_BROKER',
});

const brokerSchema = new schema.Entity('data', {}, { idAttribute: 'brokerId' });

export const getBrokersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await brokerApi.getBrokers(params);

  return dispatch({
    type: BROKERS_ACTION_TYPE.GET_BROKERS,
    payload: normalize(data, [brokerSchema]).entities.data,
  });
});

export const createBrokerAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await brokerApi.createBroker(params);

  return dispatch({
    type: BROKERS_ACTION_TYPE.CREATE_BROKER,
    payload: data,
  });
});

export const editBrokerAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await brokerApi.editBroker(params);

  return dispatch({
    type: BROKERS_ACTION_TYPE.EDIT_BROKER,
    payload: data,
  });
});

export const deleteBrokerAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await brokerApi.deleteBroker(params);

  return dispatch({
    type: BROKERS_ACTION_TYPE.DELETE_BROKER,
    payload: data,
    meta: params,
  });
});
